'use client'

import { createContext, ReactNode, useContext, useState } from 'react'
import { StripeCustomerStatus } from '../actions/stripe/getStripeCustomerStatus'

// Create the context
const StripeCustomerStatusContext = createContext<StripeCustomerStatus | null>(
  null,
)

// Modify TeacherProvider to accept an `initialTeacher` prop
export const StripeCustomerStatusProvider = ({
  initialStatus,
  children,
}: {
  initialStatus: StripeCustomerStatus | null
  children: ReactNode
}) => {
  const [status] = useState<StripeCustomerStatus | null>(initialStatus)

  return (
    <StripeCustomerStatusContext.Provider value={status}>
      {children}
    </StripeCustomerStatusContext.Provider>
  )
}

// Custom hook to use the TeacherContext
export const useStripeCustomerStatus = () => {
  return useContext(StripeCustomerStatusContext)
}
